import mediator from "@tvg/mediator";

export const onBackButtonClickGtmEvent = (module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:CLICK_BACK_BUTTON",
    payload: {
      module
    }
  });

export const onEditClickGtmEvent = (formSection, module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:CLICK_EDIT",
    payload: {
      formSection,
      module
    }
  });

export const onClickAwayFromFormGtmEvent = (
  linkText,
  module,
  destinationUrl
) => {
  mediator.base.dispatch({
    type: "REGISTRATION:CLICK_LINK_AWAY_FROM_FORM",
    payload: {
      linkText,
      module,
      destinationUrl
    }
  });
};
